jQuery(document).ready(function ($) {

	//ABRIR MENU MOBILE
	$('.abrir-menu-container, .menu-mobile .botao-fechar').click(function(e) {
		e.preventDefault();
		if(!$('.menu-mobile').hasClass('menu-site-aberto')) {
			abreMenu();
		} else {
			fechaMenu();
		}
	});
	$('.menu-overlay').click(function(e) {
		e.preventDefault();
		if(!$('.menu-overlay').hasClass('menu-overlay-aberto')) {
			abreMenu();
		} else {
			fechaMenu();
		}
	});
	function abreMenu() {
		$('.menu-mobile').addClass('menu-site-aberto');
		$('.menu-overlay').addClass('menu-overlay-aberto');
	}
	function fechaMenu() {
		$('.menu-mobile').removeClass('menu-site-aberto');
		$('.menu-overlay').removeClass('menu-overlay-aberto');
	}

	//BALAO DO WHATS
	$('a.whats').click(function(e) {
		closeWhatsBallon();
	});

	$('.whats-balao').hover(function(e) {
		closeWhatsBallon();
	});

	function closeWhatsBallon() {
		$('.whats-balao').remove();
	}

	setTimeout( function() { closeWhatsBallon(); }, 10000);

  //STICKY SIDEBAR
  $('.sticky-sidebar').theiaStickySidebar({
    'additionalMarginTop': 340,
    'minWidth': 780,
    'updateSidebarHeight':true
  });

	//GALERIA
	$('.galeria-page a, a.galeria-campo, a.fotos-capa').magnificPopup({
		type: 'image',
		gallery:{
			enabled:true,
			tPrev: 'Anterior',
			tNext: 'Próxima',
			tCounter: '%curr% de %total%'
		}
	});

	//CARROSSEIS
	$('.cursos-carrosel').owlCarousel({
		loop:false,
		margin:10,
		autoplay:false,
		autoplayTimeout:5000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		autoHeight: false,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:2
			},
			1000:{
				items:3
			}
		}
	});

	$('.depoimentos-carrosel').owlCarousel({
		loop:true,
		margin:30,
		autoplay:true,
		autoplayTimeout:12000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		autoHeight: true,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:1
			},
			1000:{
				items:2
			}
		}
	});

	//FIX HEADER
	window.onscroll = function() { fixHeader() };
	function fixHeader() {
		if (window.pageYOffset > 70) {
			$('#topo').addClass('scrooled');
		} else {
			$('#topo').removeClass('scrooled');
		}
	}

	$('a.sem-link').click(function(e) {
		e.preventDefault();
	});

});